var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button",
    {
      class: {
        "shadow-btn": _vm.shadow,
        "shadow-btn-pseudo": _vm.pseudoShadow,
        "fit-content": _vm.fitContent,
        "btn-negative": _vm.negative,
        "font-weight-bold": _vm.bold,
        "darken-on-hover": _vm.darkenOnHover,
        "no-hover": _vm.noHoverStyles
      },
      style: _vm.getOverridenStyles,
      attrs: {
        id: _vm.id,
        variant: _vm.getVariant,
        size: _vm.size,
        disabled: _vm.disabled
      },
      on: { click: _vm.click }
    },
    [
      _vm.icon
        ? _c("base-icon", {
            staticClass: "mr-2",
            attrs: {
              src: _vm.icon,
              color:
                _vm.iconColor ||
                (_vm.lastInternalTextColor || _vm.internalTextColor)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _vm._t("default")
        : _c("b-spinner", {
            attrs: { variant: "light", label: "Spinning", small: "" }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ca6f122", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ca6f122","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/buttons/BaseButton.vue
// module id = 1549
// module chunks = 116